module.exports = __webpack_public_path__ + "media/images/iconNotification--red-d999e1f38fcd8c441451aac1bb84e360.png";